import React from 'react';

interface NamespaceTagProps {
    prefix: string;
    color?: string;  // Hex color or undefined (default violet)
    onClick?: (event: React.MouseEvent) => void;
    darkMode?: boolean;
    readOnly?: boolean;  // If true, no hover effects or interaction
}

export const NamespaceTag: React.FC<NamespaceTagProps> = ({ prefix, color, onClick, darkMode, readOnly = false }) => {
    const [isHovered, setIsHovered] = React.useState(false);

    // Default to violet if no color specified
    const lightBg = color ? `${color}1a` : 'rgba(139, 92, 246, 0.1)';  // 10% opacity
    const lightText = color || 'rgb(139, 92, 246)';
    const darkBg = color ? `${color}33` : 'rgba(180, 140, 255, 0.2)';  // 20% opacity
    const darkText = color || 'rgba(180, 140, 255, 1)';

    const bg = darkMode ? darkBg : lightBg;
    const textColor = darkMode ? darkText : lightText;

    return (
        <span
            className={`ml-1.5 text-[9px] font-semibold uppercase tracking-wide px-1.5 py-0.5 rounded align-middle inline-flex items-center gap-1 ${readOnly ? '' : 'cursor-pointer transition-all'}`}
            style={{
                backgroundColor: bg,
                color: textColor,
                boxShadow: !readOnly && isHovered ? `0 0 0 1px ${textColor}` : 'none',
            }}
            onClick={readOnly ? undefined : onClick}
            onMouseEnter={readOnly ? undefined : () => setIsHovered(true)}
            onMouseLeave={readOnly ? undefined : () => setIsHovered(false)}
            title={readOnly ? undefined : "Click to change color"}
        >
            {prefix}
            {!readOnly && isHovered && (
                <svg width="10" height="10" viewBox="0 0 10 10" style={{ opacity: 0.7 }}>
                    <path d="M2 8 L2 4 Q2 2 4 2 L8 2" fill="none" stroke="currentColor" strokeWidth="1" />
                    <circle cx="8" cy="2" r="1.5" fill="currentColor" />
                </svg>
            )}
        </span>
    );
};
